import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { ordersClient } from "@core/clients";
import { queryClient } from "../../config/query-client";
import { OrderReviewType } from "@core/types";

const useAddReviewSetOrder = (
  orderNumber: string,
  options: UseMutationOptions<OrderReviewType | null, any, OrderReviewType> = {},
) => {
  return useMutation(
    ["review", "add"],
    async (orderReqData) => {
      return ordersClient.addReviewOrder(orderReqData);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: ["review", orderNumber] });
        queryClient.invalidateQueries({ queryKey: ["orders"] });
        queryClient.invalidateQueries({ queryKey: ["unreviewed-orders"] });
        queryClient.invalidateQueries({ queryKey: ["order", orderNumber] });
        options?.onSuccess?.(data, variables, context);
      },
      ...options,
    },
  );
};

export default useAddReviewSetOrder;
